export const firebaseConfig = {
    apiKey: "AIzaSyAdmczbZEOkKJOrUxCGw_cNNK2ZDTHa6Ow",
    authDomain: "navigation-menu-sm-prod.firebaseapp.com",
    projectId: "navigation-menu-sm-prod",
    storageBucket: "navigation-menu-sm-prod.appspot.com",
    messagingSenderId: "563841975366",
    appId: "1:563841975366:web:99af16e9a0fa04598cb647",
};

const PROD_HOSTING_URL = "https://navigation-menu-sm-prod.web.app";
const isNode = (typeof process !== 'undefined') && ((process as any).release?.name === 'node');
export const isRunningInDevMode = () => isNode ? (process as any).argv.includes('dev-mode') : location.host.includes("ngrok") || location.host.includes("lynk.sh") || location.host.includes("localhost") || location.host.includes("loophole.site");

function getHostingURL() {
    if (isRunningInDevMode()) {
        console.log("Running in dev mode");
        try{
            const {DEV_TUNNEL_URL} = require("../../../dev-tunnel.js");
            return DEV_TUNNEL_URL;
        } catch (e) {
            console.error("Failed to load dev-tunnel.js", e);
            throw e;
        }
    }
    return PROD_HOSTING_URL;
}

export const HOSTING_URL = getHostingURL();
const CLOUD_RUN_BASE_URL = "https://navigation-6sl3gsp6dq-ew.a.run.app";
export const API_SERVICE_URL = isRunningInDevMode() ? HOSTING_URL + "/api/navigation" : CLOUD_RUN_BASE_URL + "/api/navigation";
export const STORAGE_BUCKET_CLIENT_IMAGES = "navigation-menu-sm-prod-client-images";
export const ATLASSIAN_PLUGIN_KEY = "seibertmedia.navigation";
